<template>
  <MenuItem as="li" class="cursor-pointer block px-4 py-2 text-sm" :class="classes" @click="$emit('click')">
    <slot>Menu Item</slot>
  </MenuItem>
</template>

<script>

import {MenuItem} from '@headlessui/vue'

export default {
  name: "UiDropdownItem",
  components: {MenuItem},
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: {
    click: null,
  },
  computed: {
    classes() {
      return {
        'text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900 cursor-pointer': !this.disabled,
        'text-gray-400 cursor-not-allowed': this.disabled
      }
    }
  }
}
</script>

<style scoped>

</style>